export const LOGIN_ERROR = 'loginError';
export function setLoginError(loginError) {
    localStorage.setItem(LOGIN_ERROR, loginError);
}
export function getLoginError() {
    return localStorage.getItem(LOGIN_ERROR) || '';
}
export function clearLoginError() {
    localStorage.removeItem(LOGIN_ERROR);
}
//# sourceMappingURL=loginErrorHelper.js.map